import { ReactElement, useMemo } from 'react';
import {
  ListScratchpadPartsFragment,
  Scratchpad,
} from '../../../api/graphql/generated';
import i18n from '../../../i18n';
import { ScratchpadPlaylistPartsStatus } from '../playlist/scratchpad-playlist.hooks';
import { ScratchpadCardBase } from './scratchpad-card-base';
import './scratchpad.css';

export interface ScratchpadProps {
  scratchpad: ListScratchpadPartsFragment;
  status?: ScratchpadPlaylistPartsStatus;
  onClick?: (scratchpad: Partial<Scratchpad>) => void;
}

const ScratchpadCard = (props: ScratchpadProps): ReactElement => {
  const { scratchpad, status, onClick } = props;

  const topRight = useMemo(() => {
    if (status) {
      // fallback to on playlist label if the status didn't have a label populated
      const label = status?.label ?? i18n.t('common:scratchpad_on_playlist');
      return <div style={{ color: 'var(--ion-color-primary' }}>{label}</div>;
    }
  }, [status]);

  const className = status?.isLoaded
    ? 'scratchpad-loaded'
    : 'scratchpad-not-loaded';

  return (
    <ScratchpadCardBase
      scratchpad={scratchpad}
      className={className}
      rightSubtitle={topRight}
      onClick={onClick}
    />
  );
};

export { ScratchpadCard };
